module.exports = __webpack_public_path__ + "img/web_2.bfc8f19b.png";